import React from "react";
import { scaleLinear } from "d3-scale";
import {
  ComposableMap,
  Geographies,
  Geography,
  Sphere,
  Graticule,
  //ZoomableGroup,
} from "react-simple-maps";
import { useUser } from "../contexts/useUser";
import { useQuery } from "@tanstack/react-query";
import { fetchLLMCallsRecursive } from "../dataaccess/fetchLLMCalls";
import { Box, Typography } from "@mui/material";

import { features } from "./worldmap";

const geoUrl = features;

const colorScale = scaleLinear().domain([0, 100]).range(["#ffedea", "#ff5233"]);

const MapChart = () => {
  const { project } = useUser();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["calls", { projectId: project?.id }],
    queryFn: () => fetchLLMCallsRecursive(project?.id ?? "", 100, true),
    enabled: project?.id && project?.id.length > 0 ? true : false,
  });

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Error...</div>;
  }

  const callsData = data?.data?.callsByProjectIdAndCreatedAt?.items ?? [];

  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h6">Calls by Country</Typography>
      <ComposableMap>
        <Sphere stroke="#E4E5E6" strokeWidth={0} />
        <Graticule stroke="#E4E5E6" strokeWidth={0.1} />
        {callsData.length > 0 && (
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const callCount = callsData.filter(
                  (call) =>
                    call.country?.toLowerCase() ===
                    geo.properties.name.toLowerCase()
                ).length;

                return (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={colorScale(callCount)}
                  />
                );
              })
            }
          </Geographies>
        )}
      </ComposableMap>
    </Box>
  );
};

export default MapChart;

/*

<ZoomableGroup center={[0, 0]} zoom={1}>
  </ZoomableGroup> */
